import React from "react";

const AppHeaderCenterContainer = () => (
  <div className="header-center-container" />
);

export default AppHeaderCenterContainer;
